import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDFMxVHXuExVVTBB3yaYF6XUp2_FrN6yBo",
  authDomain: "transport-manager-68480.firebaseapp.com",
  projectId: "transport-manager-68480",
  storageBucket: "transport-manager-68480.appspot.com",
  messagingSenderId: "587909676296",
  appId: "1:587909676296:web:3524e613d1577883ce80bd"
};
const app = initializeApp(firebaseConfig);
export const Auth = getAuth(app);
export const firestore = getFirestore(app);
export const storage = getStorage();
